/**
 * Slideshow Banner — hadaki.co
 * Vanilla JS, zero zależności.
 * Obsługuje: fade, slide, autoplay, strzałki, kropki, swipe, klawiatura, wideo MP4.
 */
(function () {
  "use strict";

  /* =============================================
     KLASA GŁÓWNA
     ============================================= */

  class SlideshowBanner {
    constructor(wrapper) {
      this.wrapper    = wrapper;
      this.track      = wrapper.querySelector(".ssb-track");
      this.slides     = Array.from(wrapper.querySelectorAll(".ssb-slide"));
      this.dots       = Array.from(wrapper.querySelectorAll(".ssb-dot"));
      this.prevBtn    = wrapper.querySelector(".ssb-arrow--prev");
      this.nextBtn    = wrapper.querySelector(".ssb-arrow--next");

      this.total      = this.slides.length;
      this.current    = 0;
      this.transition = wrapper.dataset.transition || "fade";
      this.autoplay   = wrapper.dataset.autoplay === "true";
      this.delay      = parseInt(wrapper.dataset.delay) || 5000;
      this.timer      = null;
      this.isAnimating = false;

      this._sx = 0;
      this._dragging = false;

      if (this.total === 0) return;

      this._goto(0, true);
      if (this.total > 1) this._bind();
      if (this.autoplay && this.total > 1) this._startTimer();
    }

    /* =============================================
       NAWIGACJA PUBLICZNA
       ============================================= */

    next() { this._goto((this.current + 1) % this.total); }
    prev() { this._goto((this.current - 1 + this.total) % this.total); }

    /* =============================================
       PRZEJŚCIE MIĘDZY SLAJDAMI
       ============================================= */

    _goto(index, instant = false) {
      if (this.isAnimating && !instant) return;
      if (index === this.current && !instant) return;

      this.isAnimating = true;

      if (this.transition === "slide" && this.track) {
        this.track.style.transition = instant ? "none" : "";
        this.track.style.transform = `translateX(-${index * 100}%)`;
      }

      this.slides.forEach((s, i) => {
        const active = i === index;
        s.classList.toggle("ssb-slide--active", active);
        s.setAttribute("aria-hidden", active ? "false" : "true");

        // Pause/play wideo tła
        const video = s.querySelector("video.ssb-slide__bg-img");
        if (video) {
          if (active) { video.currentTime = 0; video.play().catch(() => {}); }
          else { video.pause(); }
        }
      });

      this.dots.forEach((d, i) => {
        const active = i === index;
        d.classList.toggle("ssb-dot--active", active);
        d.setAttribute("aria-selected", String(active));
      });

      this.current = index;

      setTimeout(() => { this.isAnimating = false; }, 750);
      this._resetTimer();
    }

    /* =============================================
       OBSŁUGA ZDARZEŃ
       ============================================= */

    _bind() {
      this.prevBtn?.addEventListener("click", () => this.prev());
      this.nextBtn?.addEventListener("click", () => this.next());

      this.dots.forEach((dot) => {
        dot.addEventListener("click", () => this._goto(parseInt(dot.dataset.index)));
      });

      this.wrapper.setAttribute("tabindex", "0");
      this.wrapper.addEventListener("keydown", (e) => {
        if (e.key === "ArrowLeft")  { e.preventDefault(); this.prev(); }
        if (e.key === "ArrowRight") { e.preventDefault(); this.next(); }
      });

      this.wrapper.addEventListener("mouseenter", () => this._stopTimer());
      this.wrapper.addEventListener("mouseleave", () => this._startTimer());
      this.wrapper.addEventListener("focusin",    () => this._stopTimer());
      this.wrapper.addEventListener("focusout",   () => this._startTimer());

      this._initSwipe();
    }

    /* =============================================
       OBSŁUGA SWIPE / DRAG
       ============================================= */

    _initSwipe() {
      const el = this.wrapper;
      const getX = (e) => (e.touches ? e.touches[0].clientX : e.clientX);

      const start = (e) => { this._dragging = true; this._sx = getX(e); };
      const end   = (e) => {
        if (!this._dragging) return;
        this._dragging = false;
        const diff = this._sx - getX(e);
        if (Math.abs(diff) > 45) diff > 0 ? this.next() : this.prev();
      };

      el.addEventListener("touchstart", start, { passive: true });
      el.addEventListener("touchend",   end);
      el.addEventListener("mousedown",  start);
      el.addEventListener("mouseup",    end);

      el.addEventListener("click", (e) => {
        if (Math.abs(this._sx - (e.clientX || 0)) > 10) e.preventDefault();
      });
    }

    /* =============================================
       AUTOPLAY — TIMER
       ============================================= */

    _startTimer() {
      if (!this.autoplay || this.total <= 1) return;
      this._stopTimer();
      this.timer = setInterval(() => this.next(), this.delay);
    }

    _stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
    }

    _resetTimer() {
      if (this.autoplay) { this._stopTimer(); this._startTimer(); }
    }
  }

  /* =============================================
     INICJALIZACJA
     ============================================= */

  function init() {
    document.querySelectorAll(".ssb-wrapper:not([data-ssb-init])").forEach((el) => {
      el.setAttribute("data-ssb-init", "1");
      el._ssb = new SlideshowBanner(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* =============================================
     INTEGRACJA Z EDYTOREM SHOPIFY
     ============================================= */

  document.addEventListener("shopify:section:load",    init);
  document.addEventListener("shopify:section:reorder", init);
  document.addEventListener("shopify:block:select",    (e) => {
    const wrapper = e.target.closest(".ssb-wrapper");
    if (wrapper?._ssb) {
      const idx = Array.from(wrapper.querySelectorAll(".ssb-slide")).indexOf(e.target);
      if (idx >= 0) wrapper._ssb._goto(idx);
    }
  });

})();
